import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { extractPureTextFromRichText, Typography } from 'seagull';
import ExtraClause from '~/components/AgreementStudioPage/AgreementStudioModal/ExtraClause/ExtraClause';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
function AgreementNoteContent(param) {
    let { draft, setDraft } = param;
    const form = useForm({
        defaultValues: {
            extraClause: draft.extraClause() || ''
        }
    });
    const [showAgreementSettingsWarning, setShowAgreementSettingsWarning] = useState(false);
    return /*#__PURE__*/ _jsx(FormProvider, _object_spread_props(_object_spread({}, form), {
        children: /*#__PURE__*/ _jsx(ExtraClause, {
            showAgreementSettingsWarning: showAgreementSettingsWarning,
            onValidation: (isValid)=>{
                if (isValid) return;
                setShowAgreementSettingsWarning(true);
            },
            hideLabel: true,
            onChange: (v)=>{
                setDraft(draft.setExtraClause(JSON.stringify(v)));
            }
        })
    }));
}
export default function AgreementNoteCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const onClick = ()=>onOpenModal({
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: t.agreementNote(),
                    testId: 'edit-agreement-note-modal',
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    },
                    content: /*#__PURE__*/ _jsx(AgreementNoteContent, {
                        draft: draft,
                        setDraft: setDraft
                    })
                };
            }
        });
    const extraClause = draft.extraClause();
    const pureText = useMemo(()=>extractPureTextFromRichText(extraClause).trim(), [
        extraClause
    ]);
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-agreement-note-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: "agreement-note-".concat(index),
            skin: pureText ? 'standard' : 'secondary',
            children: pureText || 'Not set'
        })
    });
}
